import axios, { AxiosResponse } from 'axios';

import { ViewAmostraAtual } from '@models/views/view-amostra-atual.model';
import { Amostra } from '@models/amostra.model';
import { Laudo } from '@models/laudo.model';
import { RecebeLaboratorioDto } from '@/../../back/src/amostras/dto/recebe-laboratorio.dto';
import { EnviaLaboratorioDto } from '@/../../back/src/amostras/dto/envia-laboratorio.dto';
import { EnviaLaboratorioGuarulhosDto } from '@/../../back/src/amostras/dto/envia-laboratorio-guarulhos.dto';

import { FinalizaAnaliseAmostraDto } from '@/../../back/src/amostras/dto/finaliza-analise-amostra.dto';
import { CriaEnsaioAmostraDto } from '@/../../back/src/amostras/dto/cria-ensaio-amostra.dto';
import { CriaLaudoAmostraDto } from '@/../../back/src/amostras/dto/cria-laudo-amostra.dto';
import { ListaAcompanhamentoAmostrasQueryDto } from '@../../../../back/src/amostras/dto/lista-acompanhamento-amostras-query-dto';
import { ListaAmostrasFinalizadasQueryDto } from '@../../../../back/src/amostras/dto/lista-amostras-finalizadas-query.dto';
import { BuscaEnsaioAmostraPorTipoQueryDto } from '@../../../../back/src/amostras/dto/busca-ensaio-amostra-por-tipo-query.dto';
import { VoltaEtapaDto } from '@/../../back/src/amostras/dto/volta-etapa.dto';
import { SolicitaAnaliseAmostraDto } from '@/../../back/src/amostras/dto/solicita-analise-amostra.dto';
import { Bag } from '@models/bag.model';
import { ViewEnsaioAtual } from '@models/views/view-ensaio-atual.model';
import { AmostraLog } from '@models/amostra-log.model';
import { Ensaio } from '@models/ensaio.model';
import { AmostrasScopesEnum } from '../../../back/src/amostras/amostras.constants';
import { Arquivo } from '@models/arquivo.model';
import { JoinAmostraArquivo } from '@models/join-amostra-arquivo';

const listaLaboratorioGuarulhos = async (): Promise<ViewAmostraAtual[]> => {
  const res = await axios.get<ViewAmostraAtual[]>(
    '/amostras/laboratorio_guarulhos',
  );
  return res.data;
};

const busca = async (
  amostraId: number,
  queryObj?: { scope: AmostrasScopesEnum },
): Promise<Amostra> => {
  const res = await axios.get<Amostra>(`/amostras/${amostraId}`, {
    ...(queryObj ? { params: queryObj } : {}),
  });
  return res.data;
};

const buscaLaudo = async (amostraId: number): Promise<Amostra> => {
  const res = await axios.get<Amostra>(`/amostras/${amostraId}/laudo`);
  return res.data;
};

const buscaAtual = async (amostraId: number): Promise<ViewAmostraAtual> => {
  const res = await axios.get<ViewAmostraAtual>(`/amostras/${amostraId}/atual`);
  return res.data;
};

const solicitaAnalise = async (
  amostraId: number,
  formData: SolicitaAnaliseAmostraDto,
): Promise<Amostra> => {
  const res = await axios.post<Amostra>(
    `/amostras/${amostraId}/solicitar_analise`,
    formData,
  );
  return res.data;
};

const enviaLaboratorioGuarulhos = async (
  formData: EnviaLaboratorioGuarulhosDto,
): Promise<Amostra[]> => {
  const res = await axios.post<Amostra[]>(
    '/amostras_utinga/enviar_laboratorio_guarulhos',
    formData,
  );
  return res.data;
};

const recebeLaboratorioGuarulhos = async (
  amostraId: number,
  formData: FormData,
): Promise<Amostra> => {
  const res = await axios.patch<Amostra>(
    `/amostras/${amostraId}/receber_laboratorio_guarulhos`,
    formData,
  );
  return res.data;
};

const enviaLaboratorio = async (
  formData: EnviaLaboratorioDto,
): Promise<Amostra[]> => {
  const res = await axios.post<Amostra[]>(
    '/amostras/enviar_laboratorio',
    formData,
  );
  return res.data;
};
const recebeLaboratorio = async (
  formData: RecebeLaboratorioDto,
): Promise<Amostra[]> => {
  const res = await axios.post<Amostra[]>(
    '/amostras/receber_laboratorio',
    formData,
  );
  return res.data;
};

const listaLaboratorio = async (): Promise<ViewAmostraAtual[]> => {
  const res = await axios.get<ViewAmostraAtual[]>('/amostras/laboratorio');
  return res.data;
};

const listaLaboratorioCatalisadoresAtivas = async (): Promise<
  ViewAmostraAtual[]
> => {
  const res = await axios.get<ViewAmostraAtual[]>(
    '/amostras/laboratorio/catalisadores/ativas',
  );
  return res.data;
};

const listaLaboratorioGeralAtivas = async (): Promise<ViewAmostraAtual[]> => {
  const res = await axios.get<ViewAmostraAtual[]>(
    '/amostras/laboratorio/geral/ativas',
  );
  return res.data;
};

const listaAmostrasFinalizadas = async (
  queryDto: ListaAmostrasFinalizadasQueryDto,
): Promise<{
  count: number;
  rows: ViewAmostraAtual[];
}> => {
  const res = await axios.get<{ count: number; rows: ViewAmostraAtual[] }>(
    '/amostras/finalizadas',
    {
      params: queryDto,
    },
  );
  return res.data;
};

const listaLaboratorioFireAssay = async (): Promise<ViewAmostraAtual[]> => {
  const res = await axios.get<ViewAmostraAtual[]>(
    '/amostras/laboratorio/fire_assay',
  );
  return res.data;
};

const listaAcompanhamento = async (
  queryDto: ListaAcompanhamentoAmostrasQueryDto,
): Promise<{
  count: number;
  rows: ViewAmostraAtual[];
}> => {
  const res = await axios.get<{ count: number; rows: ViewAmostraAtual[] }>(
    '/amostras/acompanhamento',
    {
      params: queryDto,
    },
  );
  return res.data;
};

const remove = async (amostraId: number): Promise<Amostra> => {
  const response = await axios.delete<Amostra>(`/amostras/${amostraId}`);
  return response.data;
};

const voltaEtapa = async (
  amostraId: number,
  formData: VoltaEtapaDto,
): Promise<Amostra> => {
  const res = await axios.patch<Amostra>(
    `/amostras/${amostraId}/voltar_etapa`,
    formData,
  );
  return res.data;
};
const buscaArquivos = async (
  amostraId: number,
  arquivoId: number,
): Promise<AxiosResponse> => {
  const res = await axios.get(`/amostras/${amostraId}/arquivos/${arquivoId}`);
  return res;
};
const buscaFotoAmostra = async (
  amostraId: number,
  arquivoId: number,
): Promise<AxiosResponse> => {
  const res = await axios.get(`/amostras/${amostraId}/arquivo/${arquivoId}`);
  return res;
};

const listaBags = async (amostraId: number): Promise<Bag[]> => {
  const res = await axios.get<Bag[]>(`/amostras/${amostraId}/bags`);
  return res.data;
};

const geraEtiquetaPdf = async (amostraId: number): Promise<any> => {
  const res = await axios.get(`/amostras/${amostraId}/gerar_etiqueta_pdf`, {
    responseType: 'arraybuffer',
    responseEncoding: 'binary',
    headers: { 'Content-Type': 'application/pdf' },
  });
  return res.data;
};

const geraLaudoPdf = async (
  amostraId: number,
  laudoId: number,
): Promise<any> => {
  const res = await axios.get(
    `/amostras/${amostraId}/gerar_laudo_pdf/${laudoId}`,
    {
      responseType: 'arraybuffer',
      responseEncoding: 'binary',
      headers: { 'Content-Type': 'application/pdf' },
    },
  );
  return res.data;
};

const listaEnsaiosAtuais = async (
  amostraId: number,
): Promise<ViewEnsaioAtual> => {
  const res = await axios.get<ViewEnsaioAtual>(
    `/amostras/${amostraId}/ensaios_atuais`,
  );
  return res.data;
};

const finalizaAnaliseAmostra = async (
  amostraId: number,
  formData: FinalizaAnaliseAmostraDto,
): Promise<AmostraLog> => {
  const res = await axios.post<AmostraLog>(
    `/amostras/${amostraId}/finalizar_analise`,
    formData,
  );
  return res.data;
};

const criaEnsaioAmostra = async (
  amostraId: number,
  formData: CriaEnsaioAmostraDto,
): Promise<Ensaio> => {
  const res = await axios.post<Ensaio>(
    `/amostras/${amostraId}/ensaios`,
    formData,
  );
  return res.data;
};

const buscaEnsaioPorTipo = async (
  amostraId: number,
  queryDto: BuscaEnsaioAmostraPorTipoQueryDto,
): Promise<ViewEnsaioAtual> => {
  const res = await axios.get<ViewEnsaioAtual>(
    `/amostras/${amostraId}/ensaio`,
    {
      ...(queryDto ? { params: queryDto } : {}),
    },
  );
  return res.data;
};
const criaLaudoAmostra = async (
  amostraId: number,
  formData: CriaLaudoAmostraDto,
): Promise<Ensaio> => {
  const res = await axios.post<Ensaio>(
    `/amostras/${amostraId}/laudo`,
    formData,
  );
  return res.data;
};

const buscaLaudoAtual = async (amostraId: number): Promise<Laudo> => {
  const res = await axios.get<Laudo>(`/amostras/${amostraId}/laudo_atual`);
  return res.data;
};

const alteraFotoAmostra = async (
  amostraId: number,
  formData: FormData,
): Promise<Arquivo> => {
  const res = await axios.patch<Arquivo>(
    `/amostras/${amostraId}/altera_foto_amostra`,
    formData,
  );
  return res.data;
};

const adicionaFotoAnexoAmostra = async (
  amostraId: number,
  formData: FormData,
): Promise<Arquivo> => {
  const res = await axios.patch<Arquivo>(
    `/amostras/${amostraId}/adiciona_foto_anexo_amostra`,
    formData,
  );
  return res.data;
};

const removeArquivoAnexo = async (
  amostraId: number,
  arquivoId: number,
): Promise<JoinAmostraArquivo> => {
  const response = await axios.delete<JoinAmostraArquivo>(
    `/amostras/${amostraId}/remove_arquivo/${arquivoId}`,
  );
  return response.data;
};

export default {
  adicionaFotoAnexoAmostra,
  alteraFotoAmostra,
  busca,
  buscaArquivos,
  buscaAtual,
  buscaEnsaioPorTipo,
  buscaFotoAmostra,
  buscaLaudo,
  buscaLaudoAtual,
  criaEnsaioAmostra,
  criaLaudoAmostra,
  enviaLaboratorio,
  enviaLaboratorioGuarulhos,
  finalizaAnaliseAmostra,
  geraEtiquetaPdf,
  geraLaudoPdf,
  listaAcompanhamento,
  listaAmostrasFinalizadas,
  listaBags,
  listaEnsaiosAtuais,
  listaLaboratorio,
  listaLaboratorioCatalisadoresAtivas,
  listaLaboratorioFireAssay,
  listaLaboratorioGeralAtivas,
  listaLaboratorioGuarulhos,
  recebeLaboratorio,
  recebeLaboratorioGuarulhos,
  remove,
  removeArquivoAnexo,
  solicitaAnalise,
  voltaEtapa,
};
